import React from 'react'
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, TextArea, Grid, Checkbox, Message, Icon } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import LoadingComponent from '../../../../common/LoadingComponent'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// changes made for KLM-8917 KLM-8921
// Update made for KLM-8931
class EditSystemNotificationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      description: this.props.description, 
      startDate: new Date(this.props.expdate),
      EditSystemNotificationError: null,
      // formcyButtonDisabled: false
    }

    this.handleExpDate = this.handleExpDate.bind(this);
    this.onSubmitSystemNotification = this.onSubmitSystemNotification.bind(this);
    // this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
    this.updateText = this.updateText.bind(this)
  }

  handleExpDate(date) {
    this.setState({
      startDate: date
    })
  }

  // buttonDisabled = (e, set) => {
  //   this.setState({ formcyButtonDisabled: set });
  // }

  async onSubmitSystemNotification(formData, data, name) {
    //debugger;
    try {
      //   this.setState({
      //     title: this.props.title,
      //     description: this.props.description,
      //     expDate: this.props.expdate,
      // })
      let nodeToAdd = {
        _id: this.props.id,
        title: this.state.title,
        description: this.state.description,
        expDate: this.state.startDate,
        // accountId: this.props.accountId,
        // organizationId: this.props.organizationId,
      }
      
      if (this.props.organization) {
        nodeToAdd.organizationId = this.props.organization.id
      }

      if (this.props.routeParams) {
        nodeToAdd.routeParams = this.props.routeParams
      }
      await dispatch.systemNotification.editSystemNotification(nodeToAdd);
      this.setState({ EditSystemNotificationError: null })
      this.props.closeModal()
      window.location.reload(false)
    }
    catch (err) {
      throw err
      this.setState({ EditSystemNotificationError: err })
    }

  }

  updateText(data, name ) {
    if (name === "Title") {
      this.setState({ title: data })
    } else if (name === "Description") {
      this.setState({ description: data })
    } else if (name === "Expiry Date") {
      this.setState({ expDate: data })
    }
  }

  // updateText(data, name) {

  //   if (name === "Name") {
  //     this.setState({ name: data })
  //   }

    // if (name === "Name" && data.toLowerCase() === "others" && this.props.levelDepth === "category") {
    //   this.setState({
    //     EditSystemNotificationError: {
    //       code: 409,
    //       message: 'The word is reserved for Sub category listing !'
    //     }
    //   })
    // } else {
    //   let isSameNameExist = false;
    //   let sameNameCategories = this.props.allCategories.filter((category) => {
    //     return category.name.toLowerCase().trim() === data.toLowerCase().trim();
    //   })
    //   if (sameNameCategories.length > 0) {
    //     isSameNameExist = true
    //   }
    //   if (isSameNameExist) {
    //     this.setState({
    //       EditSystemNotificationError: {
    //         code: 409,
    //         message: 'SystemNotification with same name already exists.'
    //       }
    //     })
    //   } else {
    //     this.setState({
    //       EditSystemNotificationError: null
    //     })
    //   }
    // }

  // }

  render() {
    let loading = <LoadingComponent active={this.props.loading} message="Adding..." />
    let titleLimitMsg = this.state.title.length > 25 ? <p className="clr-red">Max Limit is of 25 characters.</p> : <p>Remaining {25-this.state.title.length} / 25</p>
    let desLimitMsg = this.state.description.length > 100 ? <p className="clr-red">Max Limit is of 100 characters.</p> : <p>Remaining {100-this.state.description.length} / 100</p>
    let errorMsg = this.state.EditSystemNotificationError ?
      <span className='clr-red'>
        {this.state.EditSystemNotificationError.message}
      </span>
      : null
    
    return (
      <Modal
        open={this.props.isEditSystemNotificationModalOpen}
        onClose={this.props.closeModal}
        size='tiny'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >

        {loading}
        <Form noValidate
          className="formcyForm"
          ref={ref => this.form = ref}
          id="EditSystemNotificationForm"
          onValidSubmit={(event) => { this.onSubmitSystemNotification(event) }}
        >
          <Modal.Content style={{ padding: "20px 20px 0 20px" }}>
          <div className="ui header">Edit Notification</div>
            
            <TextEditor
              name="Title"
              text={this.state.title}
              type="text"
              onChangeText={this.updateText}
              autoFocus={true}
            />
            {titleLimitMsg}
            {errorMsg}

            {/* <Form.TextArea
                required
                name="Description"
                label="Description"
                id=""
                type="textarea"
                value={this.state.description}
                onChangeText={this.updateText}
            /> */}

            <TextEditor
              name="Description"
              text={this.state.description}
              type="text"
              onChangeText={this.updateText}
            />
            {desLimitMsg}
            {errorMsg}

            <label style={{ display: 'block', marginBottom: '5px'}} className="ui form" for="Expiry Date">Expiry Date <span style={{ color: '#ff0000'}}> *</span></label>
            {/* <Icon name='calendar alternate outline exp-cal' /> */}
            <DatePicker
              selected={ this.state.startDate }
              onChange={ this.handleExpDate }
              minDate={new Date(new Date().setHours(23, 59, 59, 999))}
              name="Expiry Date"
              dateFormat="MM/dd/yyyy"
              className="ui input timelineCalendarIcon"
              placeholder={'Please select a date'} 
            />
            
            {errorMsg}

          </Modal.Content>

          {/* below changes made for KLM-8934*/}
          <Modal.Actions className="actionInFormcy">
            <Button
              className="button-submit float-right"
              id='createbtn'
              type="submit"
              disabled={this.state.EditSystemNotificationError || (this.state.title.length > 25 || this.state.description.length > 100) || (this.state.title==="" || this.state.description==="") || (this.state.startDate === "" || this.state.startDate === null)}> Update
             </Button>
            <Button
              id='cancelBtn'
              className="button-cancel"
              onClick={this.props.closeModal}> Cancel
             </Button>
          </Modal.Actions>
        </Form>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
      accessToken: state.login.accessToken,
  };
}

const connectedEditSystemNotificationModal = connect(mapStateToProps)(EditSystemNotificationModal);

export default connectedEditSystemNotificationModal